import * as THREE from "three"
import { sceneManager } from "../index"
import { quickSave } from "./SaveManager"
import { t } from "./Translate"

// In scale mode, characters are scaled with a slider along the bottom of the
// screen instead of the scale gizmo
export const usesScaleBar = (subject) =>
	sceneManager.activeGizmo === "scale" && !!subject && subject.subjectType === "Character"

let bar = null
let barSubject = null
let input = null
let output = null

export const isScaleBarFor = (subject) => !!bar && bar.classList.contains("is-active") && barSubject === subject

export const updateScaleBar = (subject = sceneManager.selectedManager.subject) => {
	if (!subject || !subject.alive || !usesScaleBar(subject)) {
		if (bar) bar.classList.remove("is-active")
		barSubject = null
		return
	}
	if (!bar) {
		bar = document.createElement("label")
		bar.id = "scale-bar"
		document.body.appendChild(bar)
	}
	if (barSubject === subject && bar.classList.contains("is-active")) {
		// Same character, but undo/redo/load may have changed its scale
		input.value = subject.base.scale.x
		output.innerText = subject.base.scale.x.toFixed(2)
		return
	}
	barSubject = subject

	const name = document.createElement("span")
	name.innerText = t("Scale")
	input = document.createElement("input")
	input.type = "range"
	input.min = 0.1
	input.max = 5
	input.step = 0.01
	input.value = subject.base.scale.x
	// Mouse/touch only: no focus by tab, no arrow/page keys
	input.tabIndex = -1
	input.onkeydown = (event) => event.preventDefault()
	output = document.createElement("output")
	output.innerText = subject.base.scale.x.toFixed(2)
	input.onpointerdown = () => {
		sceneManager.stateManager.storeSceneState()
	}
	input.oninput = () => {
		const value = parseFloat(input.value)
		output.innerText = value.toFixed(2)
		// Scale about the feet so the character stays on the ground
		const ground = new THREE.Box3().setFromObject(subject.getBoundingObject()).min.y
		subject.base.position.y = ground + (subject.base.position.y - ground) * (value / subject.base.scale.x)
		subject.base.scale.setScalar(value)
		sceneManager.requestRender()
	}
	input.onchange = () => quickSave()
	bar.replaceChildren(name, input, output)

	bar.classList.add("is-active")
}
